import "./AddStepModal.css";

import { useContext } from "react";

import { TemplateStepConstants } from "../../../../../../../constants";
import { ServiceError } from "../../../../../../../service/Shared";
import {
  ActionButtons,
  Column,
  ErrorBox,
  KanaTooltip,
  Modal,
  RadioButtonGroup,
  Row,
  Select,
  TextInput,
} from "../../../../../../../widget";
import { TasksBoardContext } from "../../TasksBoardContext";
import { useAddStepModal } from "./useAddStepModal";

interface AddStepModalProps {
  show: boolean;
  closeModal: () => void;
  workflowUuid?: string;
}

export const AddStepModal = ({ show, closeModal, workflowUuid }: AddStepModalProps): JSX.Element => {
  const { workflowStageOptions, workflowStageLabel, isRepeatableWorkflowStage } = useContext(TasksBoardContext);
  const { step, setStep, handleAddStep, isHandleAddStepLoading, onCancel, errors } = useAddStepModal({
    closeModal,
    workflowUuid,
  });

  return (
    <Modal show={show} title="Add step" onClose={onCancel}>
      {errors && errors.length > 0 && (
        <Row spacingV="ll">
          <Column offset={3} span={6}>
            <ErrorBox
              title="Please solve the below issues before saving"
              text={errors.map((error: ServiceError) => error.message)}
            />
          </Column>
        </Row>
      )}
      <form onSubmit={(e) => handleAddStep(e)}>
        <Row spacingV="ll">
          <Column offset={3} span={6}>
            <TextInput
              name="Step name"
              label="Step name*"
              placeholder="Add step name"
              value={step.stepName}
              maxLength={100}
              onChange={(value) => setStep({ ...step, stepName: value })}
            />
          </Column>
        </Row>
        <Row spacingV="ll">
          <Column offset={3} span={6}>
            <div className="AddStepModalPhaseSelectorWrapper">
              <Select
                label={`${workflowStageLabel}*`}
                placeholder={`Select ${workflowStageLabel.toLowerCase()}`}
                data={workflowStageOptions}
                value={step.phase}
                onChange={(value) => setStep({ ...step, phase: value })}
              />
            </div>
          </Column>
        </Row>
        {isRepeatableWorkflowStage(step.phase) && (
          <Row spacingV="ll">
            <Column offset={3} span={6}>
              <RadioButtonGroup
                label="Is this step repeatable for future cycle of monitoring?"
                tooltip={
                  <KanaTooltip
                    tooltipHeader=""
                    tooltipText="Select this option to repeat this step and tasks in the next cycle of monitoring"
                  />
                }
                data={TemplateStepConstants.REPEATABLE_RADIO_BUTTON_DATA}
                onChange={(value) => setStep({ ...step, isRepeatable: value.target.value })}
              />
            </Column>
          </Row>
        )}
        <Row justify="center">
          <ActionButtons onCancel={onCancel} submitButtonLabel="Save" isLoading={isHandleAddStepLoading} />
        </Row>
      </form>
    </Modal>
  );
};
